/**
 * Export director rows to CSV and trigger browser download.
 */

function escapeCsv(value) {
  const str = value == null ? '' : String(value);
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportDirectorsToCsv(directors, filename = 'directors-export.csv') {
  const headers = [
    'ID',
    'First Name',
    'Last Name',
    'Email',
    'Company',
    'Position',
    'Status',
    'Nationality',
    'Emirates ID',
    'Appointment Date',
  ];

  const rows = (directors || []).map((d) => [
    d.id ?? d.director_id,
    d.firstName ?? d.first_name,
    d.lastName ?? d.last_name,
    d.email,
    d.companyName ?? d.company_name,
    d.position,
    d.status ?? (d.is_active ? 'ACTIVE' : 'INACTIVE'),
    d.nationality,
    d.emiratesId ?? d.emirates_id,
    d.appointmentDate ?? d.appointment_date,
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCsv).join(','))
    .join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export function exportDirectorProfileToCsv(director, filename) {
  const name = `${director.firstName || 'director'}-${director.lastName || director.id}`.replace(/\s+/g, '-');
  exportDirectorsToCsv([director], filename || `director-${name}.csv`);
}
